module.exports = __webpack_public_path__ + "packs/media/images/palestra3d-ef5f9ae3e60fac037229eee4aaa57f82.jpg";